import { render, staticRenderFns } from "./SocialIdPartUploader.vue?vue&type=template&id=74858594&"
import script from "./SocialIdPartUploader.vue?vue&type=script&lang=js&"
export * from "./SocialIdPartUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports